export default [
    `1. 零售散客<br/>Retail (BAR+PKG+E-commerce)`,
    "2. 旅游批发商<br/>Wholesale (traditional+online WHL)",
    "3. 公司协议价<br/>Corporate Negotiate (local+national)",
    "4. 政府价<br/>Government",
    "5. 折扣和奖励<br/>Discount & Award",
    "6. 商务团队<br/>Business Group (MICE+Government)",
    "7. 休闲团队<br/>Leisure Group (Series+One-time)",
    "8. 合同<br/>Contracts (long-stay+crew+layover)"
].map((name, i) => ({
    name,
    key: name,
    sort: i,
    rn_forecast: 0,
    rn_budget: 0,
    rn_actual: 0,
    avg_forecast: 0,
    avg_budget: 0,
    avg_actual: 0,
    rev_forecast: 0,
    rev_budget: 0,
    rev_actual: 0,
    vsforecast: 0,
    vsbudget: 0,
    note: ''
})) 


// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.1/diff/data.js